export type DataType = {
  Id: number,
  Name: string
};

export enum DataTypes {
  Logfiles = 0,
  LabResultFiles = 1
}
